<template>
  <div id="app">
    <!--    设置中文  -->
    <a-config-provider :locale="zh_CN">
      <router-view/>
   
    </a-config-provider>
  </div>
</template>
<script>

import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
export default {
  data(){
    return{
      zh_CN
    }
  },
  created() {
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))));
    }

    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state));
    });
  }
}
</script>
<style lang="scss" scoped>

</style>
